module.exports = __webpack_public_path__ + "img/category-favorite.a8707c13.png";